/**
 * QUICK GUIDES
 *
 * Per-flow quick-guide markdown overrides for the universal guided tour system.
 * If a flow has an entry here, it replaces the auto-generated checklist derived
 * from the flow steps. Use this for richer copy, callouts, tables, and links.
 */

export type QuickGuideManifest = Record<string, string>;

export const defaultQuickGuides: QuickGuideManifest = {
  'operations-welcome': `# Welcome to Total Operations

This quick guide covers the essentials of the Operations module.

- [ ] **Overview** — Understand what Total Operations can do for your team.
- [ ] **Navigation** — Learn the main menus and where to find key actions.
- [ ] **Dashboard cards** — Customize the dashboard to surface what matters.
- [ ] **Next steps** — Start your first schedule or job request.

> Tip: You can switch to the interactive tour at any time for hands-on guidance.
`,

  'operations-dashboard': `# Operations Dashboard

Use the dashboard to monitor daily activity at a glance.

- [ ] **KPI cards** — Review open jobs, scheduled tasks, and overdue items.
- [ ] **Quick actions** — Create jobs, requests, or schedules in one click.
- [ ] **Filters** — Adjust the view by site, team, or date range.
- [ ] **Drill down** — Click any metric to see the underlying records.
`,

  'finance-welcome': `# Welcome to Total Finance

This guide introduces the core finance workflows.

- [ ] **Invoices** — Create, send, and track customer invoices.
- [ ] **Expenses** — Capture and categorize business expenses.
- [ ] **Bank reconciliation** — Match transactions against your bank feed.
- [ ] **Reporting** — Run profit & loss, tax, and aging reports.
`,
};

export function getQuickGuideOverride(
  manifest: QuickGuideManifest,
  flowId: string
): string | null {
  return manifest[flowId] || null;
}
